import { Helmet } from "react-helmet-async";

const SITE_NAME = "Michele Rago Web Designer";
const SITE_URL = "https://www.micheleragowebdesigner.com";
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;

export default function SEO({
  title = "Web Designer a Pavia | Michele Rago",
  description = "Realizzazione siti web professionali, sviluppo React, SEO e digital marketing. Aiuto aziende e professionisti ad acquisire clienti online.",
  url = SITE_URL,
  image = DEFAULT_IMAGE,
}) {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    name: SITE_NAME,
    image,
    url,
    telephone: "", // Inserisci se vuoi
    address: {
      "@type": "PostalAddress",
      addressLocality: "Pavia",
      addressRegion: "Lombardia",
      postalCode: "27100",
      addressCountry: "IT",
    },
    areaServed: ["Pavia", "Milano", "Lombardia", "Italia"],
    priceRange: "€€",
  };

  return (
    <Helmet>
      {/* Titolo */}
      <title>{title}</title>

      {/* SEO */}
      <meta name="description" content={description} />
      <meta name="author" content="Michele Rago" />
      <meta name="robots" content="index,follow" />

      {/* Canonical */}
      <link rel="canonical" href={url} />

      {/* Mobile */}
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="theme-color" content="#000000" />

      {/* Local SEO */}
      <meta name="geo.region" content="IT-PV" />
      <meta name="geo.placename" content="Pavia" />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="it_IT" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
}
